import { getMailServerType, getSieveCapabilities } from "@apps/client-sdk";
import { createStatusController, el } from "./dom.js";
import { renderKerioSieveSection } from "./kerio/index.js";
import { renderScriptingPanel } from "./scripting.js";
import { renderVacationPanel } from "./vacation.js";
export function renderSieveSection(options) {
    const host = el("div", "sieve-section-host");
    host.append(el("p", "muted", "Loading…"));
    void (async () => {
        let type = "dovecot";
        try {
            type = await getMailServerType(options.storage);
        }
        catch {
            type = "dovecot";
        }
        host.replaceChildren();
        if (type === "kerio") {
            host.append(renderKerioSieveSection(options));
        }
        else {
            host.append(renderDovecotSieveSection(options));
        }
    })();
    return host;
}
function renderDovecotSieveSection(options) {
    const section = el("section", "card");
    section.append(el("h2", undefined, "Server Filters"));
    const status = el("p", "muted", "Loading…");
    section.append(status);
    const { showStatus } = createStatusController(status);
    const subnav = el("div", "sieve-subnav mt");
    const buttons = {
        vacation: el("button", "btn btn-secondary btn-sm sieve-subnav-btn active", "Vacation"),
        scripting: el("button", "btn btn-secondary btn-sm sieve-subnav-btn", "Scripting"),
    };
    for (const btn of Object.values(buttons)) {
        btn.type = "button";
        subnav.append(btn);
    }
    section.append(subnav);
    const body = el("div", "sieve-subsection mt");
    section.append(body);
    let capabilities = null;
    let active = "vacation";
    let scriptingPanel = null;
    const renderActive = () => {
        body.replaceChildren();
        scriptingPanel = null;
        if (active === "vacation") {
            body.append(renderVacationPanel({
                storage: options.storage,
                showStatus,
                capabilities,
            }));
        }
        else {
            scriptingPanel = renderScriptingPanel({
                storage: options.storage,
                root: options.root,
                showStatus,
                capabilities,
            });
            body.append(scriptingPanel.element);
        }
    };
    const setActive = (next) => {
        if (next === active)
            return;
        void (async () => {
            if (active === "scripting" && scriptingPanel) {
                if (!(await scriptingPanel.confirmDiscardIfDirty())) {
                    return;
                }
            }
            active = next;
            for (const [id, btn] of Object.entries(buttons)) {
                btn.classList.toggle("active", id === next);
            }
            renderActive();
        })();
    };
    buttons.vacation.addEventListener("click", () => setActive("vacation"));
    buttons.scripting.addEventListener("click", () => setActive("scripting"));
    void (async () => {
        showStatus("Loading server capabilities…", "muted");
        try {
            const caps = await getSieveCapabilities(options.storage);
            capabilities = {
                implementation: caps.implementation,
                extensions: caps.extensions,
                max_redirects: caps.max_redirects,
                notify: caps.notify,
            };
            status.hidden = true;
        }
        catch (error) {
            capabilities = null;
            showStatus(error instanceof Error
                ? `${error.message} (Scripting/Vacation may be limited; use Source for raw edits.)`
                : "Failed to load capabilities", "error");
        }
        renderActive();
    })();
    return section;
}
